import { Box, Text } from '@qga/roo-ui/components';

const CampaignMessage = ({ text }: { text?: string }) => {
  return text ? (
    <Box
      py="3"
      px="6"
      bg="bayBlue30"
      borderRadius={['4px', null, '4px 4px 0 0']}
    >
      <Text fontSize="sm" fontWeight="bold">
        {text}
      </Text>
    </Box>
  ) : null;
};

export default CampaignMessage;
